import React from 'react';
import LegendItem from './LegendItem.js';
import { ABOVE, BELOW, ERROR, SUCCESS, TYPICAL } from '../costBenchmarkTexts.js';

const Legend = () => (
  <div className="custom-legend" aria-label="Chart Legend">
    <LegendItem label={ABOVE} color={ERROR} />
    <LegendItem label={TYPICAL} />
    <LegendItem label={BELOW} color={SUCCESS} />
  </div>
);

export default Legend;
